import React, {type ReactNode, useContext} from 'react';

import {Group} from '@pb/kit-component-group';
import {LocaleContext} from '@pb/kit-context-locale';

import {getCost, getCredits} from '../../../../utils';
import {textAlignRight} from '../../../tabs-structure.module.styl';

import type {CreditBalance} from 'src/openapi/admin/models/CreditBalance';

const Column = ({caption, children}: {caption: string, children: ReactNode}) => (
    <Group direction="v" gap="xs">
        <strong>{caption}</strong>
        <div className={textAlignRight}>{children}</div>
    </Group>
);

type Props = {
    creditBalanceInfo: CreditBalance,
    costPerCredit: number | null,
    overageCost: number | null,
};
export const PricingTable = (props: Props) => {
    const {creditBalanceInfo, costPerCredit, overageCost} = props;
    const {locale} = useContext(LocaleContext);

    const getCostValue = (value: number | null) => {
        return value === null ? '-' : getCost(value, locale);
    };

    const {creditChange, creditUsed, overageUsed} = creditBalanceInfo;

    return (
        <Group gap="xl">
            <Column caption="Cost per Credit">
                {getCostValue(costPerCredit)}
            </Column>
            <Column caption="Credits Used">
                {getCredits(creditUsed, locale)}
            </Column>
            <Column caption="Credits Changed">
                {getCredits(creditChange, locale)}
            </Column>
            <Column caption="Overage Cost">
                {getCostValue(overageCost)}
            </Column>
            <Column caption="Overage Used">
                {getCredits(overageUsed, locale)}
            </Column>
        </Group>
    );
};
